export default "__VITE_ASSET__C1yxLtZr__"